/* Policy pages: hide Shopify's own heading so the policy content supplies its own title. */
(() => {
  if (!window.location.pathname.includes('/policies/')) return;

  const hideTitle = () => {
    const title = document.querySelector('.shopify-policy__title');
    if (title) title.style.display = 'none';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideTitle);
  } else {
    hideTitle();
  }
})();
